<!--
 * @Author: yejian
-->
<template>
    <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import { autoToolTip } from "@/utils/echartsAutoTooltip.js";
import * as echarts from 'echarts';
export default {
    name: 'echart',
    props: {
        className: {
            type: String,
            default: 'chart'
        },
        id: {
            type: String,
            default: 'chart'
        },
        width: {
            type: String,
            default: '100%'
        },
        height: {
            type: String,
            default: '100%'
        },
        options: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            chart: null
        }
    },
    watch: {
        options: {
            handler(options) {
                // 设置true清空echart缓存
                this.chart.setOption(options, true)
            },
            deep: true
        }
    },

    mounted() {
        this.initChart();
        
    },
    beforeDestroy() {
        this.chart.dispose()
        this.chart = null
    },
    methods: {
        async initChart() {
            // 初始化echart
            console.log(this.$el, 1324);
            this.chart = echarts.init(this.$el)
            this.chart.setOption(this.options, true)
            setTimeout(() => {
                autoToolTip(this.chart, this.options, {
                    interval: 2000,// 轮播间隔时间 默认2s
                    loopSeries: true,// 是否循环轮播所有序列
                    seriesIndex: 0,// 第1个被轮播的序列下标
                })
            }, 1000);

        }
    }
}
</script>

<style></style>